export default __webpack_public_path__ + "static/infosec-650fb490a3d80c7549be72d46abf238f.png";